import React, { useContext } from 'react';
import { WindowManagerContext } from '../context/WindowManager';
import PrimaryButton from './PrimaryButton';

const RecommendationButton = props => {
  const { openWindow } = useContext(WindowManagerContext);
  return (
    <PrimaryButton
      style={{
        width: 180,
        height: 80,
        float: 'right',
        marginTop: -50,
        marginRight: 24,
        fontSize: 20,
        lineHeight: 1.1,
        paddingTop: 17,
        zIndex: 100,
        clear: 'both',
        position: 'absolute',
        right: 16
      }}
      className='shadowed'
      onClick={() => openWindow('createRating', { clinic: props.clinic, department: props.department })}
    >
      Bewertung schreiben
    </PrimaryButton>
  );
}
;
export default RecommendationButton;
